export const siteName = "Jessie Trice Community Health System, Inc"
export const siteCode = "JTCHS"
export const continueUrl = "https://my.SmartViewMD.com"
export const siteDomains = [ "doctors.test", "jtchs.org" ] 
export const siteLogo = `/img/${siteCode}_354x123.png`
export const siteLogoSmall = `/img/${siteCode}_102x93.png`

export const doctors = [ 
    { value: "",                                 label: "* Select your primary"             },
    { value: "Dr. Joycelyn Lawrence, MD",        label: "Dr. Joycelyn Lawrence, MD"         },
    { value: "Dr. Fatima Zafar, MD",             label: "Dr. Fatima Zafar, MD"              },
    { value: "Dr. Aliuska Carmenate, MD",        label: "Dr. Aliuska Carmenate, MD"         },
    { value: "Dr. Sadia Ali, MD",                label: "Dr. Sadia Ali, MD"                 },
    { value: "Dr. Arianne Cordon-Duran, MD",     label: "Dr. Arianne Cordon-Duran, MD"      },
    { value: "Dr. Natalia Uribe, MD",            label: "Dr. Natalia Uribe, MD"             },
    { value: "Dr. Rachel Pyngolil, MD",          label: "Dr. Rachel Pyngolil, MD"           },
    { value: "Dr. Teresa Jackson, APRN",         label: "Dr. Teresa Jackson, APRN"          },
    { value: "Darline Francois, APRN",           label: "Darline Francois, APRN"            },
    { value: "Tashara Redding, APRN",            label: "Tashara Redding, APRN"             },
    { value: "Jidlyne Cherelus, APRN",           label: "Jidlyne Cherelus, APRN"            },
    { value: "Dr. Venus Miller, APRN",           label: "Dr. Venus Miller, APRN"            },
//  { value: "Dr. Leo Jusme, SVMD",              label: "Dr. Leo Jusme, SVMD DemoTest"      },
//  { value: "Dr. D. Northecide, SVMD",          label: "Dr. D. Northecide, SVMD DemoTest"  },
]

  //export default doctors;